/**
 * Created by nguyenlet on 4/1/2016.
 *
 */
import {
  Http,
  Headers,
  BaseRequestOptions,
  Request,
  RequestOptions,
  RequestOptionsArgs,
  RequestMethod,
  Response
} from '@angular/http';
import {Observable} from 'rxjs/Observable';

import {
  Injectable,
  Injector,
  ViewContainerRef,
  Directive,
  Attribute
} from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { DocumentRef } from "./refs";
import { Notification } from "./notification";
import { AppConstants } from '../shared/constants/constants';
import { environment } from '../../environments/environment';

declare const $:any;
/**
 * Allows for explicit authenticated HTTP requests.
 */


/**
 * Helper class to decode and find JWT expiration.
 */

export class AuthHelper {
  public static resetLocalStorage() {
    localStorage.clear();
  }

  public static setupAuthorizeLocalStorage(profile) {
    if (profile) {
      localStorage.setItem('profile', JSON.stringify(profile));
      localStorage.setItem('access_token', profile["access_token"]);
      localStorage.setItem('access_username', profile["userName"]);
      localStorage.setItem('access_avatarUrl', profile["avatarUrl"]);
      localStorage.setItem('access_expire', profile[".expire"]);
      localStorage.setItem('refresh_token', profile["refresh_token"]);
    }
  }

  public static jQueryAjaxSetup() {
    //We setup here for jQuery ajax
    var doc = new DocumentRef();

    $(doc.nativeDocument).ajaxError(function (event, request, settings) {
      if (request.status === 401 && request.statusText === "Unauthorized") {
        window.location.href = '/landing'; //go to landing page
      } else if (request.status === 403) {
        Notification.notify(null, 'danger', 'Do not have permission to edit this item.');
      }
    });

    $.ajaxSetup({
      beforeSend: function (xhr) {
        let token = localStorage.getItem('access_token');
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.setRequestHeader('Accept', 'application/json');
        if (token) {
          xhr.setRequestHeader('Authorization', `bearer ${token}`);
        }
      }
    });

  }

  public static get publicRoutes():string[] {
    return ['landing', '404'];
  }

  public static tokenNotExpired(tokenName?:string, jwt?:string) {
  /*  let authToken:string = tokenName || 'access_token';
    let token:string;

    console.log('check token not expired');

    token = jwt && jwt !== 'undefined' ? jwt : localStorage.getItem(authToken);

    return !(!token || token === 'undefined');*/
    let authToken:string = tokenName || AppConstants.localStorage.token;
    let token:string = jwt && jwt !== 'undefined' ? jwt : localStorage.getItem(authToken);
    if (token || token !== 'undefined') {
      const currentDate = new Date();
      const currentTime = currentDate.valueOf();
      const lastAccessDate = new Date(localStorage.getItem(AppConstants.localStorage.lastAccessDate));
      const sessionTime =  lastAccessDate.setSeconds(lastAccessDate.getSeconds() + environment.sessionExpiredDuration);
      if (sessionTime < currentTime) {
          return false;
      }
      const expireDate = localStorage.getItem(AppConstants.localStorage.expireDate);
      return (currentTime < (new Date(expireDate)).valueOf());
    }
    return false;
  }

  public static isSelectedCentre(){
    return (localStorage.getItem(AppConstants.localStorage.centreId) !== 'undefined');
  }

  public static isLoggedIn(url) {
    return AuthHelper.publicRoutes.indexOf(url) !== -1 || AuthHelper.tokenNotExpired();
  }
}

/**
 * Checks for presence of token and that token hasn't expired.
 * For use with the @CanActivate router decorator and NgIf
 */



/*
 @Directive({
 selector: 'magic-router-outlet'
 })
 export class LoggedInRouterOutlet extends RouterOutlet {
 publicRoutes: Array<string>;
 private parentRouter: Router;


 constructor(
 _viewContainer: ViewContainerRef, _loader: DynamicComponentLoader,
 _parentRouter: Router, @Attribute('name') nameAttr: string
 ) {
 super(_viewContainer, _loader, _parentRouter, nameAttr);

 this.parentRouter = _parentRouter;
 this.publicRoutes = ['login', 'signup', 'forgetpassword', 'resetpassword'];
 }

 activate(instruction: ComponentInstruction) {
 console.log('isActive?');
 if (this._canActivate(instruction.urlPath)) {
 return super.activate(instruction);
 }

 this.parentRouter.navigate(['Login']);
 }



 _canActivate(url) {
 return this.publicRoutes.indexOf(url) !== -1 || tokenNotExpired();
 }
 }*/



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/common/auth.helper.ts